<template>
  <div class="form-row inline-label">
    <div class="form-column confirm-payment">
      <label for="confirmPayment">{{ $t('paymentSelection.storeUserPaymentConfirmedLabel') }}<span>&nbsp;*</span></label>
      <input
        id="confirmPayment"
        :value="storeUserPaymentConfirmed"
        :checked="storeUserPaymentConfirmed"
        type="checkbox"
        @click="onConfirmPayment()">
      <ul v-if="validation.$error" class="ui-state-error" role="alert" aria-atomic="true" aria-live="polite">
        <li v-if="!validation.required">{{ $t('paymentSelection.validation.storeUserPaymentConfirmed.required') }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoreUserPaymentConfirmedRow',
  props: {
    validation: {
      type: Object,
      default: null
    },
    storeUserPaymentConfirmed: {
      type: Boolean,
      default: false
    },
    selectedPaymentMethod: {
      type: Object,
      default: null
    }
  },
  methods: {
    onConfirmPayment: function () {
      this.$emit('toggleConfirmPayment')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/payment-selection/StoreUserPaymentConfirmedRow.vue